import './App.css';
import {BrowserRouter as Router} from 'react-router-dom';
import {QueryClientProvider} from '@tanstack/react-query';
import {ToastContainer} from 'react-toastify';
import {queryClient} from './queryClient';
import {SecurityInitializer, GoogleOAuthProvider} from './wrappers';
import AppRoutes from './routes/AppRoutes';
import { SidebarProvider } from './components/layout';
import {useAuthSession} from './hooks/useTokenRefresh';

/**
 * Composant interne pour utiliser les hooks
 * (Les hooks ne peuvent pas être utilisés directement dans App)
 */
function AppWithAuth() {
  // Gérer le refresh automatique du token et l'inactivité
  // - Vérifier le token toutes les 10 minutes
  // - Rafraîchir 5 minutes avant expiration
  // - Déconnecter après 30 minutes d'inactivité
  useAuthSession(10, 5, 60);

  return (
    <div className="App">
      <AppRoutes />
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
}

function App() {
  return (
    <GoogleOAuthProvider>
      <QueryClientProvider client={queryClient}>
        <Router>
          <SecurityInitializer>
            <SidebarProvider>
              <AppWithAuth />
            </SidebarProvider>
          </SecurityInitializer>
        </Router>
      </QueryClientProvider>
    </GoogleOAuthProvider>
  );
}

export default App;
